// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11I7N","placeholdersHeader":"styles_placeholdersHeader__Q0uPu","editorStyle":"styles_editorStyle__3SBoi","placeholdersBox":"styles_placeholdersBox__rl7Kl"};